import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { NavigationMenuEntry } from '@app/shared/core/models/navigation-menu-entry.interface';
import { basicLayoutActions } from '../../state/actions';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { XROSSOVER_APP_LOGIN } from '@app/shared/constants/xross-over-external-urls.constant';

@Component({
    selector: 'app-side-bar',
    templateUrl: './side-bar.component.html',
    styleUrls: ['./side-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SideBarComponent {
  @Input() menuItems: NavigationMenuEntry[] = [];
  @Input() sidebarState: 'in' | 'out' = 'in';
  @Input() currentRoute!: any;

  constructor(private store: Store) {}

  closeSidebar() {
    this.store.dispatch(basicLayoutActions.setSidebarVisibility({ opened: false }));
    this.sidebarState = 'out';
  }

  goToStore() {
    window.open(XROSSOVER_APP_LOGIN);
  }
}
